import * as s from "./AdminModalStyled";
import SmallPopupDefaultTemplate from "components/templates/modal/small/SmallPopupDefaultTemplate";
import BigButton from "components/atoms/buttons/BigButton";
import { useAppSelector } from "redux/hooks";
import { ReactComponent as AccountSVG } from "assets/icons/sidenav/account.svg";
import { getAccountTimeFormatDate } from "utils/timeUtil";
import moment from "moment";
import { useLocalStorage } from "hook/useLocalStorage";

interface Props {
  onModal: () => void;
}

export default function ExpiredAdminModal(props: Props) {
  const selectedAccount = useAppSelector((state) => state.accountSettings);
  const [checkedDontShow, setCheckedDontShow] = useLocalStorage(
    `${selectedAccount.accountId}-expired-owner`,
    false
  );

  const ButtonArea = () => {
    return (
      <s.AccessButtonWrapper>
        <div
          onClick={() => setCheckedDontShow(!checkedDontShow)}
          data-testid="users-admin-admin-div-set-checked-dont-show"
        >
          <input type="checkbox" checked={checkedDontShow} readOnly />
          <label>Don't show this message again</label>
        </div>
        <BigButton
          label="OK"
          onClickBtn={() => {
            props.onModal();
          }}
          data-testid="users-admin-admin-button-modal"
        />
      </s.AccessButtonWrapper>
    );
  };

  return (
    <SmallPopupDefaultTemplate
      onModal={() => props.onModal()}
      button={<ButtonArea />}
    >
      <s.AccessNotifyWrapper>
        <s.AccessNotifyTitle>
          <AccountSVG /> Access Notice
        </s.AccessNotifyTitle>
        <p>
          You have access to the <b>"{selectedAccount.accountName}"</b>{" "}
          Organization until{" "}
          <b>
            {selectedAccount.createdAt &&
              moment(
                getAccountTimeFormatDate(
                  selectedAccount.createdAt,
                  selectedAccount
                )
              )
                .add(30, "days")
                .format("MMM DD, YYYY")}
          </b>
        </p>
      </s.AccessNotifyWrapper>
    </SmallPopupDefaultTemplate>
  );
}
